import { createActions, createReducer } from 'reduxsauce'

const meses = [
    { value: '01', label: 'Janeiro' },
    { value: '02', label: 'Fevereiro' },
    { value: '03', label: 'Marco' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Maio' },
    { value: '06', label: 'Junho' },
    { value: '07', label: 'Julho' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' },
]
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaMetasEducacao: ['exercicio'],
    setMesLiquidacaoConsultaMetasEducacao: ['mesLiquidacao'],
    setDescricaoMetaConsultaMetasEducacao: ['descricaoMeta'],
    limpaFiltroConsultaMetasEducacao: [],
    receberFiltroConsultaMetasEducacao: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    mesLiquidacao: { value: meses[new Date().getMonth()].value, label: meses[new Date().getMonth()].label },
    descricaoMeta: '',
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setMesLiquidacao = (state = INITIAL_STATE, action) => {
    return { ...state, mesLiquidacao: action.mesLiquidacao }
}

const setDescricaoMeta = (state = INITIAL_STATE, action) => {
    return { ...state, descricaoMeta: action.descricaoMeta }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_METAS_EDUCACAO]: setExercicio,
    [Types.SET_MES_LIQUIDACAO_CONSULTA_METAS_EDUCACAO]: setMesLiquidacao,
    [Types.SET_DESCRICAO_META_CONSULTA_METAS_EDUCACAO]: setDescricaoMeta,
    [Types.LIMPA_FILTRO_CONSULTA_METAS_EDUCACAO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_METAS_EDUCACAO]: receberFiltro,
})
